<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <block-group-form :group="group" :errors="errors" @onSubmit="submit"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { BlockGroup } from '../../../../models/blockGroup';
import BlockGroupForm from '../../../../components/blocks/BlockGroupForm';

export default {
  name: 'Edit',
  components: { BlockGroupForm },
  data: () => ({
    group: {},
    errors: {},
    page: {
      title: "Группы блоков"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Группы блоков",
        disabled: true,
        to: '/block-groups'
      },
      {
        text: "Редактирование",
        disabled: true,
        to: '/block-groups/create'
      },
    ]
  }),
  created() {
    this.find();
  },
  methods: {
    async submit(form) {
      try {
        this.errors = {};
        await BlockGroup.$query().update(form.id, form);
        await this.$router.push('/block-groups');
      } catch (e) {
        if (e.response?.data) {
          this.errors = e.response.data.errors
        }
        throw e;
      }
    },
    async find() {
      const group = await BlockGroup.$query().find(this.$route.params.id);
      this.group = group.$attributes;
    }
  },
  watch: {
    'group.id': {
      handler(newTitle) {
        this.page.title +=  ` "${newTitle}"`;
      }
    },
  }
};
</script>

<style scoped>

</style>
